module.exports = __webpack_public_path__ + "img/claim1.6e9574dd.png";